import { render, staticRenderFns } from "./MarkdownEditor.vue?vue&type=template&id=b0a2d4c6&scoped=true&"
import script from "./MarkdownEditor.vue?vue&type=script&lang=js&"
export * from "./MarkdownEditor.vue?vue&type=script&lang=js&"
import style0 from "./MarkdownEditor.vue?vue&type=style&index=0&id=b0a2d4c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0a2d4c6",
  null
  
)

export default component.exports